import type { DataTableHeader } from '@/types/vuetify';

export function createProxyPageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        {
            title: '',
            value: 'select',
            key: 'select',
            align: 'center',
            sortable: false,
            minWidth: 26,
            width: 26,
            cellProps: { class: 'px-0' },
            headerProps: { class: 'px-0' },
        },
        {
            title: t('proxy.columns.name'),
            value: 'name',
            key: 'name',
            align: 'start',
            sortable: true,
            nowrap: true,
            minWidth: 80,
        },
        {
            title: t('proxy.columns.accountCount'),
            value: 'count_accounts',
            key: 'count_accounts',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 44,
            width: 48,
        },
        {
            title: t('proxy.columns.hostname'),
            value: 'ip',
            key: 'ip',
            align: 'start',
            sortable: true,
            nowrap: true,
            minWidth: 100,
        },
        {
            title: t('proxy.columns.betCount'),
            value: 'count_bets_settled',
            key: 'count_bets_settled',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 52,
            width: 56,
        },
        {
            title: t('proxy.columns.abnCount'),
            value: 'count_bets_abnormal',
            key: 'count_bets_abnormal',
            align: 'center',
            sortable: true,
            nowrap: true,
            minWidth: 52,
            width: 56,
        },
        {
            title: t('proxy.columns.abnPerc'),
            value: 'abn_perc',
            key: 'abn_perc',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 56,
            width: 64,
        },
        {
            title: t('proxy.columns.type'),
            value: 'type',
            key: 'type',
            align: 'start',
            sortable: true,
            nowrap: true,
            minWidth: 56,
        },
        {
            title: t('proxy.columns.login'),
            value: 'login',
            key: 'login',
            align: 'start',
            sortable: true,
            nowrap: true,
            minWidth: 72,
        },
        {
            title: t('proxy.columns.isActive'),
            value: 'is_active',
            key: 'is_active',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 44,
            width: 48,
        },
        {
            title: t('proxy.columns.isAgent'),
            value: 'is_agent',
            key: 'is_agent',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 44,
            width: 48,
        },
        {
            title: t('proxy.columns.connectTime'),
            value: 'connect_time',
            key: 'connect_time',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 80,
        },
        {
            title: t('proxy.columns.totalTime'),
            value: 'total_time',
            key: 'total_time',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 80,
        },
        {
            title: t('proxy.columns.lastCheck'),
            value: 'last_checked_at',
            key: 'last_checked_at',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 88,
        },
        {
            title: t('proxy.columns.bookmakers'),
            value: 'proxy_site',
            key: 'proxy_site',
            align: 'start',
            sortable: false,
            nowrap: true,
            minWidth: 120,
        },
        {
            title: '',
            value: 'actions',
            key: 'actions',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 120,
            cellProps: { class: 'pl-0 pr-1' },
        },
    ];
}
